import { render } from "./Recordings.vue?vue&type=template&id=f086df4e&scoped=true"
import script from "./Recordings.vue?vue&type=script&lang=js"
export * from "./Recordings.vue?vue&type=script&lang=js"

import "./Recordings.vue?vue&type=style&index=0&id=f086df4e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f086df4e"]])

export default __exports__